import { ApiManager, ApiManagerDefault } from "../ApiManager";
import { Axios } from "../config/ApiConfig";

interface UpdatePushTopkenType {
  tokenId: string;
}

/**
 * App과 연동되는 API 리스트
 */
export default class ApiGlobal extends ApiManager {
  private static classInstance: ApiGlobal;

  private GLOBAL_USER = "/api/v2/global/user";

  public static getInstance(initValue: ApiManagerDefault): ApiGlobal {
    if (!ApiGlobal.classInstance) {
      this.classInstance = new ApiGlobal(initValue);
    }
    return this.classInstance;
  }

  public globalUser = (token: string) => {
    return Axios.Client({
      header: { token },
      method: "post",
      url: this.GLOBAL_USER,
    });
  };
}
